var scope_0 = require('/opt/gatsby/voxology/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6e8b6923eee6769821b6bae42063f201.js').default;
var scope_1 = require('/opt/gatsby/voxology/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/opt/gatsby/voxology/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e9b39da5e1ed79fa2dff5502da7ac802.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    